import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { Alert, Box, Button, Dialog, TextField } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector, dispatch } from '../../../redux/store';
import { setOpen, getCaDeatails, getPartyList } from '../../../redux/slices/capanel';
import axios from '../../../utils/axios';

export default function PartyForm() {

  const { enqueueSnackbar } = useSnackbar();
  const [err, setErr] = useState(null);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');

  const open = useSelector((state) => state.capanel.open);

  const caDetails = useSelector((state) => state.capanel?.caDetails);

  // console.log(customerName,email)

  const handleClose = () => {
    dispatch(setOpen(false));
  };

  useEffect(() => {
    dispatch(getCaDeatails());
  }, []);

  const handleSave = async () => {
    const caEmail = caDetails?.email;
    const caName = caDetails?.customerName;
    try {
      await axios.post('/CaPanel/add_party', {
        userName,
        password,
        caEmail,
        caName,
      });
      enqueueSnackbar('Add Party Successfully')
      dispatch(getPartyList());
      dispatch(setOpen(false));

    } catch (e) {
      setErr(e?.message);
    }
  };

  return (
    <Dialog
      open={open}
      //   onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
   { err && <Alert severity='error'>{err}</Alert>}
      <DialogTitle id="alert-dialog-title">{'Add Party'}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box sx={{ display: 'flex', gap: 2, p: 2, flexDirection: 'column' }}>
            <TextField
              name="userName"
              label="User Name"
              type="text"
              size="small"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            <TextField
              name="password"
              label="Password"
              type="text"
              size="small"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button size="small" variant="contained" onClick={handleClose}>
          Cancel
        </Button>
        <Button size="small" variant="contained" onClick={handleSave} autoFocus>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
